import React from 'react';
import { ModalContent, ModalFooter } from 'fronton-react';
import { ButtonWithGAClickButton, ModalHeader, Typography } from 'common/components';
import { ENTRANCE_DOORS_ELEMENT_BLOCK } from '../../../../entrance-doors-constants';

type IndividualSizeProps = {
  onConsultationSignupBtnClick: () => void;
};

export const IndividualSize = ({ onConsultationSignupBtnClick }: IndividualSizeProps) => (
  <>
    <ModalHeader title="Индивидуальные размеры" />
    <ModalContent>
      <Typography variant="m" size="body_long">
        Наши мастера изготовят дверь любого нестандартного размера. Для высоких проёмов делаем двери
        с&nbsp;надставкой или фрамугой, а&nbsp;для широких&nbsp;&mdash; двери с&nbsp;дополнительными боковыми
        панелями или боковыми створками.
      </Typography>
    </ModalContent>
    <ModalFooter>
      <ButtonWithGAClickButton
        elementBlock={ENTRANCE_DOORS_ELEMENT_BLOCK}
        elementName="Индивидуальные размеры"
        elementText="Оставить заявку"
        onClick={onConsultationSignupBtnClick}
        wide>
        Оставить заявку
      </ButtonWithGAClickButton>
    </ModalFooter>
  </>
);
